import React from "react";
import TableWrapper from "../elements/TableWrapper";
import moment from "moment";
import TierProfile from "../elements/TierProfile";
import {
  Row,
  Col,
  Input,
  Modal,
  message,
  Select, Icon
} from "antd";
import MiCompAPI from "../../util/api";
import AliceCarousel from 'react-alice-carousel'
const { Option } = Select;

class ClientPlans extends React.Component {
  profile_columns = [
    {
      title: "Profile Name",
      dataIndex: "tier_profile_name",
      sorter: (a, b) => a.tier_profile_name.localeCompare(b.tier_profile_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      sorter: (a, b) => a.plan_name.localeCompare(b.plan_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Plan Id",
      dataIndex: "client_plan_Id",
    },
    {
      title: "Company Name",
      dataIndex: "client_name",
      sorter: (a, b) => a.client_name.localeCompare(b.client_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "IsOverride",
      render: (text, record) => (record["override_tier_value"] !== 0 && record["override_tier_value"] !== null) ? 'Yes' : 'No',
    },
    {
      title: "Override Value",
      render: (record) => (record["override_tier_value"] !== 0 && record["override_tier_value"] !== null) ? record["override_tier_value"] + "%" : 'none'
    },
    {
      title: "Action",
      dataIndex: "",
      render: (record) => <> <i className="fa fa-eye fa-b" onClick={() => { this.GetClient_TierandProfileById(record) }} /> </>
    },
  ];
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      Tiers: [],
      Tiers1: [],
      slideToIndex: 0,
      isProfileShow: false,
      profile: [],
      record: [],
      carrier: [],
      carrier_id: 0,
      loas: [],
      loa: "0"

    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.getTiersByClientIdandLoBID(this.state.carrier_id, this.state.loa);
    this.GetUserCarriers();
    this.GetLoA(0);
  };
  GetUserCarriers = () => {
    this.api.invoke(
      "GetUserCarriers",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              carrier: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  GetLoA = (carrier_id) => {
    if(carrier_id===0){
      this.api.invoke(
        "GetMasters",
        "post",
        (data, success) => {
          if (success) {
            this.setState({
              loas: data._lobs,
            });
          }
        },
        ["LOBS"]
      );
    }else{
      this.api.invoke(
        "GetLoAID/" +
        carrier_id,
        "get",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              this.setState({
                loas: data.data,
              });
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        },
        undefined,
        undefined
      );
    }
   
  };
  GetClient_TierandProfileById = (data) => {
    this.api.invoke(
      "GetClient_TierandProfileById/" +
      data.tier_profile_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            this.setState({
              isProfileShow: true,
              record: { ...data.data.Tier_Profile, client_TierADataModel: data.data.Tier },
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  getTiersByClientIdandLoBID = (clientid, loa) => {
    this.api.invoke(
      "GetAllUser_Teirs/" + clientid + "/" + loa,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              loading: false,
              Tiers: data.data.map(x => ({ ...x, isActiveTab: false })),
              Tiers1: data.data.map(x => ({ ...x, isActiveTab: false })),
            });
            this.GetCurrentClient_Broker_ProfilesbyTierID(data.data[0]);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  GetCurrentClient_Broker_ProfilesbyTierID = (tier) => {
    this.setState({
      Tiers: this.state.Tiers.map((x, index) => {
        if (x.tier_id === tier.tier_id) {
          this.setState({
            slideToIndex: index
          })
          return { ...x, isActiveTab: true }
        } else {
          return { ...x, isActiveTab: false }
        }
      }),
    });
    const { decodedToken } = this.props.userPermandMasters;
    var userid = decodedToken.UserId;
    this.api.invoke(
      "GetCurrentClient_User_ProfilesbyTierID/" +
      tier.tier_id + "/" + userid,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              loading: false,
              profile: data.data ? [{ ...data.data }] : [],
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  Change = (e) => {
    if (e.target.value.length > 2) {
      this.setState({
        Tiers: this.state.Tiers1.map(x => ({ ...x, isActiveTab: false })).filter(o =>
          Object.keys(o).some(k =>
            String(o[k])
              .toLowerCase()
              .includes(e.target.value.toLowerCase())
          )
        )
      })
    } else {
      this.setState({ Tiers: this.state.Tiers1 })
    }
    setTimeout(() => {
      if (this.state.Tiers.length > 0)
        this.GetCurrentClient_Broker_ProfilesbyTierID(this.state.Tiers[0]);
    }, 3);
  };
  UserDefaultHandler = (record) => {
    this.setState({
      record,
      isProfileShow: !this.state.isProfileShow
    })
  }
  onChange = (type, e) => {
    
    if (type === "carrier") {
      this.GetLoA(e);
      this.setState({
        carrier_id:e,
        loa:"0"
      })
    }
    if (type === "loa") {
      this.setState({
        loa:e
      })
    }
setTimeout(() => {
  this.getTiersByClientIdandLoBID(this.state.carrier_id, this.state.loa);

}, 100);
  }
  render() {

    return (

      <>
        {(this.state.isProfileShow) ? <Modal
          visible={this.state.isProfileShow}
        > <TierProfile Client_Tier={this.state.record.client_TierADataModel} title="Profile Details"
          Tier_Profile={this.state.record} closeDrawerHandler={() => { this.UserDefaultHandler(null) }} /></Modal> : null}
        <Row>
          <Col sm={24} md={8}>
            <p className="mi_title">
              {this.props.title
              }                </p>
          </Col></Row>
        <Row>
         
          <Col sm={24} md={8}>
            <fieldset className="mi_input_pop" style={{  marginRight: '2px' }}>

              <legend className="legend-font">Carrier</legend>
              <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                 onChange={this.onChange.bind( this,"carrier")}
                 defaultValue={this.state.carrier_id.toString()}

                optionFilterProp="children"
                showSearch={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Please Select Carrier">
                <Option value="0" key="0">All</Option>
                {this.state.carrier ? this.state.carrier.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>) : ""}
              </Select>

            </fieldset>
          </Col>
          <Col sm={24} md={8}>
            <fieldset className="mi_input_pop" style={{  marginRight: '2px' }}>

              <legend className="legend-font">LOA</legend>
              <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                onChange={this.onChange.bind( this,"loa")} optionFilterProp="children"
                showSearch={true}
                defaultValue={this.state.loa}

                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Please Select Carrier">
                <Option value="0" key="0">All</Option>
                {this.state.loas ? this.state.loas.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>) : ""}
              </Select>

            </fieldset>
          </Col>
          <Col sm={24} md={8} >
            <div style={{  marginLeft: '20px', marginTop: "24px" }}>

              <Input.Search
                style={{ marginTop: '0px', width: '100%' }}
                placeholder="Search "
                className="table-search-button"
                onChange={this.Change.bind(this)}
              />

            </div>
          </Col>
        </Row>
        {this.state.Tiers.length === 0 ?
          <Row span={24}>
            <p className="mi_noplan">
              No Plans
            </p>
          </Row> :
          <Row span={24}>
            {this.state.Tiers.length > 3 || window.innerWidth < 760 ?
              <AliceCarousel
                startIndex={this.state.slideToIndex}
                stopAutoPlayOnHover={false}
                responsive={{
                  0: { items: 1 },
                  1024: { items: 3 },
                }} dotsDisabled={true} >
                {this.state.Tiers.map((item) => {
                  return (<Col  >
                    <div className={item.isActiveTab ? "Rectangle-1" : "Rectangle-3"} onClick={() => this.GetCurrentClient_Broker_ProfilesbyTierID(
                      item)}>
                      <div style={{ transform: 'rotate(180deg)' }}>
                        <Row span={24}>
                          <Col span={15}>
                            <p className="mi_plan_title">{item.plan_Name} </p>
                          </Col>
                          <Col span={9}>
                            <p className="mi_plan_badge">{"id : " + item.client_plan_Id}</p>
                          </Col>
                        </Row>
                        <Row span={24}>
                          <Col span={12}>
                            <p className="mi_plan_start">{item.start_date ? "Start date : " + moment(item.start_date).format("MM/DD/YYYY") : 'none'} </p>
                          </Col>
                          <Col span={12}>
                            <p className="mi_plan_start" style={{ float: 'right' }}>{item.end_date ? "End date : " + moment(item.end_date).format("MM/DD/YYYY") : 'none'}</p>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>)
                })}
              </AliceCarousel> :
              this.state.Tiers.map((item) => {
                return (<Col key={item.client_plan_Id} md={8} >
                  <div className={item.isActiveTab ? "Rectangle-1" : "Rectangle-3"} onClick={() => this.GetCurrentClient_Broker_ProfilesbyTierID(
                    item)}>
                    <div style={{ transform: 'rotate(180deg)' }}>
                      <Row span={24}>
                        <Col span={15}>
                          <p className="mi_plan_title">{item.plan_Name} </p>
                        </Col>
                        <Col span={9}>
                          <p className="mi_plan_badge">{"id : " + item.client_plan_Id}</p>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={12}>
                          <p className="mi_plan_start">{item.start_date ? "Start date : " + moment(item.start_date).format("MM/DD/YYYY") : 'none'} </p>
                        </Col>
                        <Col span={12}>
                          <p className="mi_plan_start" style={{ float: 'right' }}>{item.end_date ? "End date : " + moment(item.end_date).format("MM/DD/YYYY") : 'none'}</p>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>)
              })}
          </Row>
        }
        {this.state.Tiers.length > 0 ?
          <Row span={24}>
            <div style={{ margin: '25px 10px' }}>
              <TableWrapper
                rowKey="client_plan_Id"
                columns={this.profile_columns}
                data={this.state.profile}
                pagination={false}
              />
            </div>
          </Row>
          : ""}
      </>
    );
  }
}
export default ClientPlans;
